import React from 'react';
import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/ManagerHomePage/PendingClaims/messages';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { ClaimByStatus, SagisConfig } from 'containers/AppContainer/typings';
import { formatClaim } from 'containers/AppContainer/utils';
import EmptyBloc from 'components/EmptyBloc';
import PendingFiles from 'components/SahamIcons/PendingFiles';
import ActionButton from 'components/Buttons/ActionButton';
import CardTitle from 'containers/common/Card/CardTitle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const Container = styled.div`
  .container {
    padding-right: 20px;
    min-height: 300px;
  }
  .ChevronRightIcon {
    fill: #384164;
  }
  .table {
  }
  .tableContainer {
    background-color: #f7f7f7;
    max-height: 250px;
    overflow-y: scroll;
  }
  .headerTitle {
    text-align: left;
    font-size: 12px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 0px;
    font-weight: Medium;
  }
  .row {
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-weight: Regulat;
    font-size: 13px;
    color: #2b2727;
  }
  .moreClaimsButton {
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 12px;
    opacity: 1;
    padding-left: 10px;
    font-weight: Bold;
  }
  .cardAction {
  }
  .CardContent {
  }
  .tableRow {
    cursor: pointer;
  }
`;
export interface ManagerPendingClaimsProps {
  intl: IntlShape;
  claims: ClaimByStatus[];
  cities: SagisConfig[];
}

const ManagerPendingClaims: React.FC<ManagerPendingClaimsProps> = (
  props,
): JSX.Element => {
  const formattedClaims = formatClaim(
    props.claims,
    props.cities as SagisConfig[],
  );

  return (
    <Container>
      <Card className="container">
        <CardContent className="CardContent">
          {isEmpty(props.claims) ? (
            <div>
              <EmptyBloc
                filetitle={translate(
                  { ...messages.noPendingFilesMessage },
                  props,
                )}
                fileText={translate({ ...messages.noPendingFilesTitle }, props)}
              >
                <PendingFiles />
              </EmptyBloc>
            </div>
          ) : (
            <>
              <CardTitle
                count={props.claims.length}
                message={translate({ ...messages.title }, props)}
              />
              <div className="tableContainer">
                <Table className="table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.registrationNumber }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.openingDate }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.claimPlace }, props)}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!isEmpty(props.claims) &&
                      formattedClaims.map((row: any) => (
                        <TableRow
                          key={row.id}
                          hover
                          className="tableRow"
                          onClick={pushTo(
                            `${PAGES.MANAGER_RECAP_PAGE}/${row.id}`,
                          )}
                        >
                          <TableCell align="left" className="row">
                            {row.registrationNumber}
                          </TableCell>
                          <TableCell align="left" className="row">
                            {moment(row.createAt).format('YYYY-MM-DD')}
                          </TableCell>
                          <TableCell align="left" className="row">
                            {row.lossLocationLabel}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            </>
          )}
        </CardContent>
        {!isEmpty(props.claims) && (
          <CardActions className="cardAction">
            <ActionButton
              size="small"
              title={translate({ ...messages.displayAllClaimsButton }, props)}
              onClick={pushTo(PAGES.MANAGER_PENDING_CLAIMS)}
              righticon={<ChevronRightIcon className="ChevronRightIcon" />}
            />
          </CardActions>
        )}
      </Card>
    </Container>
  );
};
export default injectIntl(ManagerPendingClaims);
